{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Палітра кольорів",
  "twoDimensionalSlider": "Повзунок 2D"
}
